// src/components/heroManagementDashboard/approvalGate/approvalAction.js

import { getFunctions, httpsCallable } from "firebase/functions";

// This helper function handles the final steps for an approved "Add User" action.
// It writes the new user document to Firestore and sends the invitation email.
export const processAddUserApprovalAction = async (params) => {
  const {
    newUserEmail,
    targetDetails, // Expected to include at least { userGroup, userRole }
    company,
    collectionBrand,
    firestoreOps,
  } = params;
  console.log("Processing 'Add User' approval action for:", newUserEmail);

  // Step 1: Create the new user document.
  const newUserDocData = {
    dateCreated: new Date().toISOString(),
    email: newUserEmail,
    state: "Invited",
    userGroup: targetDetails.userGroup,
    userRole: targetDetails.userRole,
  };

  try {
    await firestoreOps({
      operation: "write",
      company,
      collectionBrand,
      systemName: "Users",
      uniqueId: newUserEmail,
      documentData: newUserDocData,
    });
  } catch (err) {
    console.error("Error writing new user document:", err);
    throw new Error("Failed to write new user document.");
  }

  // Step 2: Send the invitation email.
  const functions = getFunctions();
  const sendEmailFn = httpsCallable(functions, "sendEmail");

  // Dynamically import uuid to generate a token.
  const { v4: uuidv4 } = await import("uuid");
  const token = uuidv4();

  // Construct the invitation link.
  const inviteLink = `https://andus.co.za/heroregister?inviteId=${encodeURIComponent(
    newUserEmail
  )}&company=${encodeURIComponent(
    company
  )}&collectionBrand=${encodeURIComponent(
    collectionBrand
  )}&email=${encodeURIComponent(newUserEmail)}&token=${encodeURIComponent(
    token
  )}`;

  // Compose the invitation email HTML.
  const subject = "Invitation to the Hero Management System";
  const htmlBody = `
    <div style="font-family: Arial, sans-serif; font-size: 14px; background-color: #2c3e50; border: 2px solid #bd932e; border-radius: 10px; padding: 20px; color: #ffffff;">
      <h1 style="font-size: 20px; color: #bd932e; text-align: center; margin-bottom: 20px;">Welcome to the Hero Management System</h1>
      <p>Hello,</p>
      <p>You have been invited to join the Hero Management System as a ${targetDetails.userRole} in the ${targetDetails.userGroup} group.</p>
      <p>Please click the button below to complete your registration:</p>
      <p style="text-align: center;">
        <a href="${inviteLink}" style="display: inline-block; background-color: #007bff; color: #ffffff; padding: 10px 20px; text-decoration: none; border-radius: 5px;">Complete Registration</a>
      </p>
      <p style="text-align: center;">Best regards,<br/>Your Hero System Team</p>
    </div>
  `;

  try {
    await sendEmailFn({
      to: newUserEmail,
      from: "Hero Admin <noreply@yourdomain.com>",
      subject,
      html: htmlBody,
      isHTML: true,
    });
  } catch (err) {
    console.error("Error sending invitation email:", err);
    throw new Error("Failed to send invitation email.");
  }

  return { success: true, token, inviteLink, newUserDocData };
};
